export default __webpack_public_path__ + "static/media/appointment.d0d01a86.png";